import { instance, DateService } from 'seismic-common';
import MockService from './MockService';
import { getParameterByName } from '../commonUtil/util';
import i18n, { getLang } from '../commonUtil/i18n';

let isMockServiceInitialized = false;
export const initializeMockService = () => {
    const useMockData = getParameterByName('useMockData');
    const isRunDemo = window.isRunDemo || false;
    if ((useMockData || isRunDemo) && !isMockServiceInitialized) {
        isMockServiceInitialized = true;
        const mockService = new MockService();
        mockService.initialize();
    }
};

export const initLanguage = () => {
    const lang = getLang();
    const dateService = instance.getService(DateService);
    dateService.setLanguage(lang);
    i18n.changeLanguage(lang);
};
